// The registry of filter criteria. Their order here is the order of the URL
// query's parameters; the filter bar orders its controls by each control's
// `order`. A new criterion: a new file in this folder (its `GameFilter`
// field, query parameter, match rule and control), and one line here.
import type { FilterCriterion } from '../criterion.ts';
import { outcome } from './outcome.ts';
import { colour } from './colour.ts';
import { timeClass } from './time-class.ts';
import { opponent } from './opponent.ts';
import { opening } from './opening.ts';
import { variation } from './variation.ts';
import { rating } from './rating.ts';
import { ending } from './ending.ts';
import { blunder } from './blunder.ts';
import { mistake } from './mistake.ts';
import { endingType } from './ending-type.ts';
import { endingResult } from './ending-result.ts';
import { middlegameResult } from './middlegame-result.ts';
import { groundCause } from './ground-cause.ts';
import { middlegamePosition } from './middlegame-position.ts';
import { conversion } from './conversion.ts';
import { stageChange } from './stage-change.ts';
import { middlegameTurn } from './middlegame-turn.ts';

export const FILTER_CRITERIA: readonly FilterCriterion[] = [
  outcome,
  colour,
  timeClass,
  opponent,
  opening,
  variation,
  rating,
  ending,
  blunder,
  mistake,
  endingType,
  endingResult,
  middlegameResult,
  groundCause,
  middlegamePosition,
  conversion,
  stageChange,
  middlegameTurn,
] as readonly FilterCriterion[];
